var SET_CLIENT_PAGINATION_STATE = 'SET_CLIENT_PAGINATION_STATE';
var SET_SERVER_PAGINATION_STATE = 'SET_SERVER_PAGINATION_STATE';
var SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_NEXT_PAGE = 'SET_NEXT_PAGE';
var SET_PREV_PAGE = 'SET_PREV_PAGE';
var SET_LAST_PAGE = 'SET_LAST_PAGE';
var SET_FIRST_PAGE = 'SET_FIRST_PAGE';
var NEXT = 'NEXT';
var PREV = 'PREV';
var FIRST = 'FIRST';
var LAST = 'LAST';
var SERVER = 'server';
var CLIENT = 'client';
var INITIAL_STATE = {
  currentPage: 1,
  pageSize: 25,
  pageSizeOptions: [25, 50, 100]
};

export { CLIENT, FIRST, INITIAL_STATE, LAST, NEXT, PREV, SERVER, SET_CLIENT_PAGINATION_STATE, SET_CURRENT_PAGE, SET_FIRST_PAGE, SET_LAST_PAGE, SET_NEXT_PAGE, SET_PAGE_SIZE, SET_PREV_PAGE, SET_SERVER_PAGINATION_STATE };
